import { decrypt } from 'src/utils/encryption/decrypt';
import getNumberOrIntermediateString from './utils/getNumberOrDash';
export default function getValue(col, row) {
    let res;
    if (!row)
        return res;
    if (col.valueGetter) {
        res = col.valueGetter({ col, row, value: row[col.field] });
    }
    else {
        res = row[col.field];
    }
    if (col.encrypted)
        res = decrypt(res);
    if (col.isNumeric && res !== null)
        res = getNumberOrIntermediateString(res);
    return res;
}
